// extracted by mini-css-extract-plugin
export default {"main_bg":"background_main_bg__M0nlF","bg_top":"background_bg_top__aLj8K","bg_bottom":"background_bg_bottom__ky3nG"};